module.exports = __webpack_public_path__ + "static/media/AX.fdc4838e.jpg";